'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

var _messageHeader = require('../message-header');

var _messageHeader2 = _interopRequireDefault(_messageHeader);

var _messageTime = require('../message-time');

var _messageTime2 = _interopRequireDefault(_messageTime);

var _combineStyles = require('../../internal/combine-styles');

var _combineStyles2 = _interopRequireDefault(_combineStyles);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

var _imageLoader = require('../../image-loader');

var _imageLoader2 = _interopRequireDefault(_imageLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  avatar: _propTypes2.default.string,
  body: _propTypes2.default.node.isRequired,
  createdAt: _propTypes2.default.string.isRequired,
  username: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.oneOf(['text', 'image', 'sticker', 'giphy', 'video', 'audio']),
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageHeaderStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageBodyStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  messageTimeStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  fontSize: _propTypes2.default.oneOf(['small', 'medium', 'large']),
  myMessage: _propTypes2.default.bool,
  compact: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  badge: _propTypes2.default.node,
  iconMenu: _propTypes2.default.node,
  imageLoaderProps: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

var defaultProps = {
  avatar: '',
  type: 'text',
  style: {},
  messageHeaderStyle: {},
  messageBodyStyle: {},
  messageTimeStyle: {},
  fontSize: 'small',
  myMessage: false,
  compact: false,
  color: _colors2.default.theme,
  badge: null,
  iconMenu: null
};

var StickerMessage = function StickerMessage(_ref) {
  var color = _ref.color,
      myMessage = _ref.myMessage,
      avatar = _ref.avatar,
      compact = _ref.compact,
      style = _ref.style,
      fontSize = _ref.fontSize,
      messageHeaderStyle = _ref.messageHeaderStyle,
      body = _ref.body,
      createdAt = _ref.createdAt,
      username = _ref.username,
      type = _ref.type,
      messageBodyStyle = _ref.messageBodyStyle,
      messageTimeStyle = _ref.messageTimeStyle,
      badge = _ref.badge,
      iconMenu = _ref.iconMenu,
      imageLoaderProps = _ref.imageLoaderProps;

  var headerStyle = (0, _combineStyles2.default)(messageHeaderStyle, { marginBottom: 0 });

  var imgProps = {
    style: _getStyles2.default.body(myMessage, avatar, compact, messageBodyStyle)
  };

  return _react2.default.createElement(
    'div',
    { style: _styles2.default.container },
    _react2.default.createElement(
      'div',
      { style: _getStyles2.default.header(color, myMessage, avatar, compact, iconMenu, style) },
      _react2.default.createElement(_messageHeader2.default, {
        avatar: avatar,
        compact: compact,
        myMessage: myMessage,
        fontSize: fontSize,
        headerStyle: headerStyle,
        username: username,
        stickerMessage: true,
        badge: badge
      }),
      _react2.default.createElement(_messageTime2.default, {
        myMessage: myMessage,
        type: type,
        style: messageTimeStyle,
        createdAt: createdAt,
        fontSize: fontSize
      }),
      iconMenu ? _react2.default.createElement(
        'div',
        { style: _styles2.default.iconMenu },
        iconMenu
      ) : null
    ),
    _react2.default.createElement(_imageLoader2.default, _extends({
      src: body,
      alt: 'user-upload',
      imgProps: imgProps
    }, imageLoaderProps))
  );
};

StickerMessage.propTypes = propTypes;
StickerMessage.defaultProps = defaultProps;

exports.default = StickerMessage;
module.exports = exports.default;